/* eslint-disable */
import P from 'prop-types';

const ConditionalChannelFilter = ({channelId, termStart, termEnd, setFilters}) => {
    const a = 1;

    return (
    <>
        {(channelId == 4 || channelId == 8) && (
        <div className="conditionalChannelFilter" >
            <span className="label-dataFilter">Filtrar por Final de Vigência:</span>

            <input type="date" name="start_date" className="input-dataFilter" 
                value={termStart} 
                onChange={ (e) => setFilters('termStart', e.target.value) } />
            <input type="date" name="end_date" className="input-dataFilter" 
                value={termEnd} 
                onChange={ (e) => setFilters('termEnd', e.target.value) } />
        </div>
        )}
    </>
     )
}

ConditionalChannelFilter.propTypes = {
  channelId: P.number,
  termStart: P.string, 
  termEnd: P.string,
  setFilters: P.func,
};

export default ConditionalChannelFilter;